import { Route } from '@angular/router';
import { DetailsComponent } from './details/details.component';
import { ListComponent } from './list/list.component';
import { LandingComponent } from './landing.component';
import { AcademyCategoriesResolver, PortfoliosResolver, ProfileResolver, ProfilesResolver } from './landing.resolver';
import { QuoteComponent } from './quote/quote.component';
import { AboutUsComponent } from './about-us/about-us.component';
import { HowItWorksComponent } from './how-it-works/how-it-works.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { ListPortfoliosComponent } from './list-portfolios/list-portfolios.component';

export const profilesRoutes: Route[] = [
    {
        path: '',
        component: LandingComponent,
        resolve: {
            categories: AcademyCategoriesResolver
        },
        children: [
            {
                path: 'contact-us',
                component: ContactUsComponent,
                data: { title: 'Contact us' }
            },
            {
                path: 'about-us',
                component: AboutUsComponent,
                data: { title: 'About us' }
            },            
            {
                path: 'how-it-works',
                component: HowItWorksComponent,
                data: { title: 'How It Works' }
            },
            {
                path: 's',
                pathMatch: 'full',
                component: ListComponent,
                resolve: {
                    courses: ProfilesResolver
                },
                data: { title: 'List Profiles' }
            },
            {
                path: 'p',
                pathMatch: 'full',
                component: ListPortfoliosComponent,
                resolve: {
                    course: PortfoliosResolver
                },
                data: { title: 'List Portfolios' }
            },
            {
                path: 'p/:skills',
                pathMatch: 'full',
                component: ListPortfoliosComponent,
                resolve: {
                    course: PortfoliosResolver
                },
                data: { title: 'List Portfolios' }
            },
            {
                path: '',
                component: ListComponent,
                resolve: {
                    courses: ProfilesResolver
                },
                data: { title: 'List Profiles' }
            },
            {
                path: 's/:id',
                component: DetailsComponent,
                resolve: {
                    course: ProfileResolver
                },
                data: { title: 'Profile' }
            },
            {
                path: 'q/:id',
                component: QuoteComponent,
                resolve: {
                    course: ProfileResolver
                },
                data: { title: 'Get A Quotation' }
            }
        ]
    }
];

// @NgModule({
//   imports: [RouterModule.forChild(profilesRoutes)],
//   exports: [RouterModule]
// })
// export class ProfilesRoutingModule { }
